const deals = [
	{
		path: '/deals/deals',
		name: 'shop-deals',
		component: () => import('@/views/shop/deals/index.vue'),
		meta: {
			layout: 'content',
			module: 'MGS,deals',
		},
	},
	{
		// Stores, integrations, clicks, commissions and collection health of the Deals in one place. The money tabs
		// answer only to platform admins: the screen asks the API (meta.can_see_money) instead of guessing.
		path: '/deals/deals-dashboard',
		name: 'shop-deals-dashboard',
		component: () => import('@/views/shop/deals/dashboard/index.vue'),
		meta: {
			layout: 'content',
			module: 'MGS,deals',
		},
	},
	{
		// Staff moderation of the deals community (hot/cold votes, comments, "expired" flags).
		path: '/deals/deal-community',
		name: 'shop-deals-community',
		component: () => import('@/views/shop/deals/community/index.vue'),
		meta: {
			layout: 'content',
			module: 'MGS,deals',
		},
	},
]

export default deals
